import { ChangeDetectionStrategy, Component, effect, model, output } from '@angular/core';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { autocompleteFilter } from 'src/app/shared/helpers/autocompleteFilter.helper';
import { DocumentoRiproduzioneRow } from 'src/app/shared/models/documentoRiproduzione.model';
import { Utente } from 'src/app/shared/models/utente.model';

@Component({
  selector: 'app-trasmetti-riproduzioni-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog [header]="'Trasmetti riproduzione ' + riproduzioneEdit.numeroOrdine" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()" >
    <label for="numeroRichiesta" class="small-label">N° richiesta</label>
    <input class="width200" id="numeroRichiesta" pInputText type="text" [(ngModel)]="riproduzioneEdit.numeroRichiesta" required>

    <label for="utente" class="small-label">Utente</label>
    <p-autoComplete inputId="utente" [(ngModel)]="riproduzioneEdit.richiedente" [suggestions]="utentiFiltrati"
      (completeMethod)="utentiFiltrati = autocompleteFilter($event, utenti, 'nomeUtente', true)" [dropdown]="true"
      [size]="20" [forceSelection]="false" [autoHighlight]="true" appendTo="body">
    </p-autoComplete>

    <label for="dataRichiesta" class="small-label">Data richiesta</label>
    <p-calendar id="dataRichiesta" [showIcon]="true" dateFormat="dd/mm/yy" [selectOtherMonths]="true" appendTo="body" [(ngModel)]="riproduzioneEdit.dataRichiesta">
    </p-calendar>
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      <button pButton type="button" icon="pi pi-check" label="Trasmetti" (click)="save()" [disabled]="!riproduzioneEdit.numeroRichiesta || !riproduzioneEdit.richiedente || !riproduzioneEdit.dataRichiesta"></button>
    </p-footer>
  </p-dialog>
  `,
  styles: [`
    label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
    label:first-of-type { margin-top: 0; }
    .width200{ width: 200px; }
  `]
})

export class TrasmettiRiproduzioniDialogComponent {
  visible = model.required<boolean>();
  riproduzione = model<DocumentoRiproduzioneRow | undefined>();
  hide = output();
  saved = output<DocumentoRiproduzioneRow>();

  public utenti: Utente[] = [];
  public utentiFiltrati: Utente[] = [];
  public autocompleteFilter = autocompleteFilter;
  public riproduzioneEdit: DocumentoRiproduzioneRow = { dataRichiesta: new Date() } as DocumentoRiproduzioneRow;

  constructor(anagraficheService: AnagraficheService) {
    anagraficheService.utenti.getAllArray(u => this.utenti = u);
    effect(() => {
      this.riproduzioneEdit = this.riproduzione() ?? { dataRichiesta: new Date() } as DocumentoRiproduzioneRow;
    });
  }

  hideDialog(): void {
    this.hide.emit();
  }

  save(): void {
    this.saved.emit(this.riproduzioneEdit);
    this.hideDialog();
  }
}
